// BU - Block unit (svg part)

export const BU_SHAPE = 'shape'
export const BU_ICON = 'icon'
export const BU_TITLE = 'title'
export const BU_CAPTION = 'caption'
export const BU_PATH_CONNECTOR_LEFT = 'path_connector_left'
export const BU_PATH_CONNECTOR_RIGHT = 'path_connector_right'
export const BU_PATH_CONNECTOR_TOP = 'path_connector_top'
export const BU_PATH_CONNECTOR_BOTTOM = 'path_connector_bottom'
export const BU_ALERT = 'alert'

export const BU_SHAPE_WIDTH = 200
export const BU_SHAPE_HEIGHT = 60
export const BU_ICON_HEIGHT = 32
export const BU_ICON_WIDTH = 32
export const BU_TITLE_SIZE = 14
export const BU_CAPTION_SIZE = 12
// Radius
export const BU_SHAPE_RX = 4
export const BU_SHAPE_RY = 4
export const BU_PATH_CONNECTOR_R = 9
// Margin
export const BU_SHAPE_MY = 100 // space around the shape (required for viewBox, for possible buttons around the shape in the future, without it shadow is not working)
export const BU_SHAPE_MX = 100
// Padding
export const BU_SHAPE_PX = 16
export const BU_SHAPE_PY = 16

export const BLOCK_OUTER_WIDTH = BU_SHAPE_WIDTH + BU_SHAPE_MX * 2
export const BLOCK_OUTER_HEIGHT = BU_SHAPE_HEIGHT + BU_SHAPE_MY * 2
export const BLOCK_CX = BU_SHAPE_MX + BU_SHAPE_WIDTH / 2
export const BLOCK_CY = BU_SHAPE_MY + BU_SHAPE_HEIGHT / 2

export const blockUnitsBoundingRect = {
    [BU_SHAPE]: {
        key: BU_SHAPE,
        x: BU_SHAPE_MX,
        y: BU_SHAPE_MY,
        rx: BU_SHAPE_RX,
        ry: BU_SHAPE_RY,
        width: BU_SHAPE_WIDTH,
        height: BU_SHAPE_HEIGHT
    },
    [BU_ICON]: {
        key: BU_ICON,
        x: BU_SHAPE_MX + BU_SHAPE_PX,
        y: BU_SHAPE_MY + BU_SHAPE_HEIGHT / 2 - BU_ICON_HEIGHT / 2,
        width: BU_ICON_WIDTH,
        height: BU_ICON_HEIGHT
    },
    [BU_TITLE]: {
        key: BU_TITLE,
        x: BU_SHAPE_MX + BU_SHAPE_PX * 2 + BU_ICON_WIDTH,
        y: BU_SHAPE_MY + BU_SHAPE_PY + BU_TITLE_SIZE - 4
    },
    [BU_CAPTION]: {
        key: BU_CAPTION,
        x: BU_SHAPE_MX + BU_SHAPE_PX * 2 + BU_ICON_WIDTH,
        y: BU_SHAPE_MY + BU_SHAPE_HEIGHT / 2 + BU_CAPTION_SIZE
    },
    [BU_PATH_CONNECTOR_LEFT]: {
        key: BU_PATH_CONNECTOR_LEFT,
        cx: BU_SHAPE_MX,
        cy: BLOCK_CY,
        r: BU_PATH_CONNECTOR_R
    },
    [BU_PATH_CONNECTOR_RIGHT]: {
        key: BU_PATH_CONNECTOR_RIGHT,
        cx: BU_SHAPE_MX + BU_SHAPE_WIDTH,
        cy: BLOCK_CY,
        r: BU_PATH_CONNECTOR_R
    },
    [BU_PATH_CONNECTOR_TOP]: {
        key: BU_PATH_CONNECTOR_TOP,
        cx: BU_SHAPE_MX + BU_SHAPE_WIDTH / 2,
        cy: BU_SHAPE_MY,
        r: BU_PATH_CONNECTOR_R
    },
    [BU_PATH_CONNECTOR_BOTTOM]: {
        key: BU_PATH_CONNECTOR_BOTTOM,
        cx: BU_SHAPE_MX + BU_SHAPE_WIDTH / 2,
        cy: BU_SHAPE_MY + BU_SHAPE_HEIGHT,
        r: BU_PATH_CONNECTOR_R
    }
}
